import { AppointmentStepperService } from './../../../services/appointment-stepper.service';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit } from '@angular/core';
import {
 FormBuilder,
 FormGroup,
 ReactiveFormsModule,
 Validators,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import {
 NzRadioGroupComponent,
 NzRadioModule,
} from 'ng-zorro-antd/radio';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { HttpService } from '../../../services/http.service';
import { StorageService } from '../../../services/storage.service';
import { UserAccountDTO } from '../../../classes/user-account.dto';
import format from 'date-fns/format';
import { ToastrService } from 'ngx-toastr';
import {
 TranslateModule,
 TranslateService,
} from '@ngx-translate/core';
import { IDocumentCard } from '../../../interfaces/document-card.interface';
import { GtmService } from '../../../services/gtm.service';
import { NzRadioGroupAccessibilityDirective } from '../../../directives/nz-radio-group-accessibility.directive';
import { AriaAutocompleteFieldComponent } from '../../shared/aria-autocomplete-field/aria-autocomplete-field.component';
import { AriaDatePickerFieldComponent } from '../../shared/aria-date-picker-field/aria-date-picker-field.component';
import { AriaFieldOption } from '../../shared';
@Component({
 selector: 'app-load-documents-modal',
 imports: [
   ReactiveFormsModule,
   NzIconModule,
   NzFormModule,
   NzRadioModule,
   NzRadioGroupAccessibilityDirective,
   NzUploadModule,
   NzProgressModule,
   NzRadioGroupComponent,
   TranslateModule,
   AriaAutocompleteFieldComponent,
   AriaDatePickerFieldComponent
 ],
 templateUrl: './load-documents-modal.component.html',
 schemas: [CUSTOM_ELEMENTS_SCHEMA],
 styleUrl: './load-documents-modal.component.scss',
})
export class LoadDocumentsModalComponent implements OnInit {
 readonly nzModalData = inject(NZ_MODAL_DATA);
 dataModal?: {
   isFromMedicalConsultations: boolean;
 };
 uploadForm?: FormGroup;
 document!: any;
 documentIsUploading = false;
 progressPercentage = '0';
 pathologyItemsSelect: AriaFieldOption[] = [];
 endDateDocument: Date = new Date();
 startDateDocument: Date = new Date(1950);
 constructor(
   private modalRef: NzModalRef,
   private http: HttpService,
   private storage: StorageService,
   private toast: ToastrService,
   private translate: TranslateService,
   private fb: FormBuilder,
   private appointmentsService: AppointmentStepperService,
   private gtmService: GtmService
 ) {}
 ngOnInit(): void {
   if (this.nzModalData) {
     this.dataModal = this.nzModalData.dataModal;
   }
   this.loadPathologyData();
   this.uploadForm = this.fb.group({
     docName: [null, [Validators.required]],
     docDate: [null, [Validators.required]],
     documentType: ['Referto visita', [Validators.required]],
     docPathology: [null],
     docNote: [null],
   });
 }
 beforeUpload = (file: any): boolean => {
   this.documentIsUploading = true;
   this.progressPercentage = '30';
   const isPDFOrImage =
     file.type === 'application/pdf' ||
     file.type.startsWith('image/jpeg') ||
     file.type.startsWith('image/png');
   if (!isPDFOrImage) {
     this.progressPercentage = '50';
     this.documentIsUploading = false;
     alert('Puoi caricare solo file PDF, JPEG o PNG.');
     return false;
   }
   this.progressPercentage = '50';
   this.progressPercentage = '80';
   this.documentIsUploading = false;
   this.document = file;
   return true;
 };
 private loadPathologyData(): void {
   this.http
     .getMedicalRecordsOptionsByKey('pathology')
     .subscribe((pathologyItems) => {
       this.pathologyItemsSelect = pathologyItems.map((item) => ({
         value: item.value,
         label: item.value,
       }));
     });
 }
 public deleteDoc(): void {
   this.document = null;
   this.documentIsUploading = false;
 }
 public closeModal(): void {
   this.modalRef.close();
 }
 public sendData(): void {
   const formData = new FormData();
   formData.append('files[0]', this.document);
   formData.append(
     'docname',
     this.uploadForm?.get('docName')?.value
   );
   formData.append(
     'docdate',
     format(
       new Date(this.uploadForm?.get('docDate')?.value),
       'yyyy-MM-dd'
     )
   );
   formData.append(
     'doctype',
     this.uploadForm?.get('documentType')?.value
   );
   const pathology = this.uploadForm?.get('docPathology')?.value;
   formData.append('docpathology', pathology ?? '');
   formData.append(
     'docnote',
     this.uploadForm?.get('docNote')?.value
   );
   formData.append(
     'doccaremanagerrequest',
     this.dataModal?.isFromMedicalConsultations
       ? this.dataModal.isFromMedicalConsultations.toString()
       : 'false'
   );
   formData.append('dossiercode', '');
   this.http.uploadDocuments(formData).subscribe((res) => {
     const documentLoaded: IDocumentCard = {
       id: res.doc.id,
       title: res.doc.documentName,
       icon: res.doc.type.startsWith('Referto')
         ? 'file-icon.svg'
         : 'file-blue.svg',
       date: format(
         new Date(res.doc.documentDate),
         'dd MMM yyyy'
       ),
       type: res.doc.type,
       additional_text: 'reportsPage.document_type',
     };
     this.appointmentsService.setDocuments(documentLoaded);
     const documentType =
       this.uploadForm?.get('documentType')?.value;
     this.gtmService.pushHealthDataEvent(
       'upload_report',
       documentType
     );
     this.modalRef.close({
       event: 'success',
       documentData: documentLoaded,
     });
     this.toast.success(
       this.translate.instant('loadDocumentModal.success')
     );
   });
 }
}